import React, { useState, useEffect } from "react";


import moment from "moment-timezone";

function LandingCurrentDateTime() {

    const [currentDate, setCurrentDate] = useState(moment().format("DD MMMM YYYY"));
     const [currentTime, setCurrentTime] = useState(moment().format("HH:mm:ss"));
   
     useEffect(() => {
       const interval = setInterval(() => {
         setCurrentDate(moment().format("DD MMMM YYYY"));
         setCurrentTime(moment().format("HH:mm:ss"));
       }, 1000); // Update every second
       return () => clearInterval(interval);
     }, []);
   
    return(
       
      <div
      className="fw-bold  text-white"
      style={{
        position: "absolute",
        top: "10px",
        right: "10px",
        padding: "5px 10px",
        borderRadius: "5px",
        opacity: 0.8,
        zIndex: 1000, // Ensures it stays above other elements
      }}
    >
      {currentDate} {currentTime}
    </div>   
    )


}

export default LandingCurrentDateTime;